// extracted by mini-css-extract-plugin
export default {"box":"ActivationCpl_box__lxFdU","title":"ActivationCpl_title__QmITJ","value":"ActivationCpl_value__Q+1n1"};